export enum SettelmentType {
    withdrawAppBalanceBySettlement = 10,
    withdrawMerchantBalanceBySettlement = 11,
}
export enum TransactionType  {
    ipgDeposit = 1,
    manualDeposit = 2,
    withdrawBySettlement = 3,
    withdrawAppBalanceBySettlement = 10,
    withdrawMerchantBalanceBySettlement = 11,
    manualWithdraw = 12,
    transferToCard = 20,
    transferToSheba = 21
}
export type TransactionReportItem = {
    transactionFactId: number,
    transactionId: number,
    gatewayName: string,
    merchantName: string,
    terminalName: string,
    applicationName: string,
    type: TransactionType,
    typeDescription: string,
    deposit: number,
    withraw: number,
    wageAmount: number,
    balance: number,
    insertDate: string,
    insertTime: string,
    description: string
}
export type TransactionAggrigationReportItem = {
    transactionAggregationId: number,
    gatewayName: string,
    merchantName: string,
    terminalName: string,
    applicationName: string,
    type: TransactionType,
    typeDescription: string,
    deposit: number,
    withraw: number,
    wageAmount: number,
    balance: number,
    insertDate: string,
    insertTime: string,
}